var _path, _g, _g2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MSHOW",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.385,
    height: 96.385,
    viewBox: "0 0 96.385 96.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "KALIMAT_IMAGE",
    "data-name": "KALIMAT IMAGE",
    d: "M12.851,0H83.534A12.851,12.851,0,0,1,96.385,12.851V83.534A12.851,12.851,0,0,1,83.534,96.385H12.851A12.851,12.851,0,0,1,0,83.534V12.851A12.851,12.851,0,0,1,12.851,0Z",
    fill: "#3c74b7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BDOUIN",
    transform: "translate(12.612 7.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2858",
    "data-name": "Groupe 2858",
    transform: "translate(0 19.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "B-2",
    "data-name": "B",
    d: "M2.349,19.019a.843.843,0,0,1-.372.786l-1.241.813c-.083.112-.29.168-.29.253s.083.168.248.168H7.189c3.392,0,6.262-1.936,6.262-6,0-3.114-2.5-4.292-4.111-4.853,1.613-.673,4.028-1.767,4.028-4.993,0-3.394-3.2-5.19-7.5-5.19H.248C.083,0,0,.084,0,.168S.207.337.29.421l1.241.814A.843.843,0,0,1,1.9,2.02ZM5.534,1.4h.62c2.027,0,2.9.926,2.9,3.787,0,3.366-.869,4.46-2.9,4.46h-.62Zm0,9.65h.62c2.027,0,2.9,1.038,2.9,3.787,0,3.787-.414,4.8-2.234,4.8H5.534Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ouin",
    transform: "translate(27.487 5.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ouin-2",
    "data-name": "ouin",
    d: "M36.448,15.63c-.166,0-.248-.028-.248-.112,0-.056.083-.14.165-.2l1.282-.982c.083-.056.083-.14.083-.252l.26-11.221c0-1.066-.455-1.627-1.406-1.627a2.269,2.269,0,0,0-2.068,2.44V14.088a.437.437,0,0,0,.041.252l1.282.982c.124.056.207.14.207.2,0,.084-.124.112-.248.112h-5.46c-.165,0-.248-.028-.248-.112,0-.056.041-.14.165-.2l1.282-.982c.083-.056.083-.14.083-.252V1.38a.239.239,0,0,0-.124-.224L30.256.37C30.173.286,30.09.2,30.09.146c0-.084.124-.112.248-.112h3.971c.165,0,.207.056.207.168v.813H34.6A4.307,4.307,0,0,1,37.453.034c2.068,0,3.433.982,3.433,2.861l-.26,11.193c0,.112,0,.2.083.252l1.282.982c.083.056.165.14.165.2,0,.084-.124.112-.248.112Zm-12.483,0c-.124,0-.248-.028-.248-.112,0-.056.083-.14.165-.2l1.282-.982c.083-.056.083-.14.083-.252l-.633-12.67a.239.239,0,0,0-.124-.224L23.25.407c-.083-.084-.166-.168-.166-.224,0-.084.124-.112.248-.112l4.6-.037c.124,0,.207.056.207.168V14.088c0,.112,0,.2.083.252l1.282.982c.083.056.165.14.165.2,0,.084-.083.112-.248.112Zm-4.8,0c-.165,0-.29-.056-.29-.112v-.954h-.083a4.044,4.044,0,0,1-2.772,1.066c-2.4,0-3.516-.954-3.516-2.861V2.273a.238.238,0,0,0-.124-.224l-1.241-.786c-.083-.084-.165-.168-.165-.224,0-.084.124-.112.248-.112h3.971c.124,0,.207.056.207.168V12.8a1.439,1.439,0,0,0,1.613,1.627,2.02,2.02,0,0,0,1.861-2.244V1.38a.239.239,0,0,0-.124-.224L17.549.37C17.424.286,17.342.2,17.342.146c0-.084.124-.112.248-.112h3.971c.165,0,.207.056.207.168V14.088a.437.437,0,0,0,.041.252l1.282.982c.124.056.207.14.207.2,0,.084-.124.112-.29.112ZM.035,7.421C-.3,1.9,1.831.173,4.474.012c2.684-.163,5.01,1.3,5.346,6.813.421,6.916-1.714,8.592-4.4,8.755q-.192.012-.382.012C2.559,15.592.436,14,.035,7.421Zm4.512-6.2c-1.074.065-1.588,1.137-1.292,6.008.384,6.3,1.02,7.217,2.093,7.151,1.115-.068,1.635-1.055,1.251-7.355C6.312,2.3,5.7,1.213,4.648,1.213,4.615,1.213,4.581,1.214,4.547,1.216Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(13.444 0.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d-2",
    "data-name": "d",
    d: "M1.983,18.984a.882.882,0,0,1-.406.784L.3,20.58c-.088.112-.3.168-.3.252S.075,21,.241,21H5.4c4.178,0,6.742-1.9,7.137-11.032C12.854,2.716,10.489,0,6.311,0H.293C.128,0,.041.084.038.168s.2.168.279.252l1.206.812a.8.8,0,0,1,.338.784ZM5.63,1.4h.745c1.613,0,3.1,1.064,2.773,8.568C8.778,18.536,7.2,19.6,5.588,19.6H4.844Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8345",
    "data-name": "Trac\\xE9 8345",
    d: "M1.106-7.176c.094,0,.141.129.141.293A11.59,11.59,0,0,1,.473-3.354C.473-5.652.86-7.176,1.106-7.176ZM1.6-.693c.68,0,1.114-.633,1.407-1.043a.442.442,0,0,0,.117-.27.274.274,0,0,0-.234-.234c-.094,0-.152.082-.234.2-.223.3-.551.774-1.032.774C.942-1.267.59-2.018.59-2.487A12.62,12.62,0,0,0,1.833-6.812c0-.727-.234-1.079-.7-1.079C.544-7.891-.195-6.637-.195-3.12-.195-1.443.708-.693,1.6-.693ZM2.982-2.451c0-.844.528-1.805.8-1.805.106,0,.164.059.164.2A2.192,2.192,0,0,1,2.982-2.451ZM3.92-.658A2.252,2.252,0,0,0,5.76-1.736a.442.442,0,0,0,.117-.27.274.274,0,0,0-.234-.234c-.094,0-.152.082-.234.2a1.8,1.8,0,0,1-1.372.868c-.563,0-.868-.246-.938-.645A3.411,3.411,0,0,0,4.576-4.081c0-.457-.2-.715-.739-.715C3.088-4.8,2.2-3.671,2.2-2.358A1.606,1.606,0,0,0,3.92-.658ZM5.667-2.416c-.164.246-.234.352-.234.5a.2.2,0,0,0,.2.211c.129,0,.258-.2.422-.445.223-.328.539-.774.821-1.219a1.6,1.6,0,0,1,.985,1.442.571.571,0,0,1-.012.141,3.949,3.949,0,0,0-.7-.129c-.375,0-.727.2-.727.574,0,.41.352.645.9.645a1.184,1.184,0,0,0,1.02-.551H8.48a1.256,1.256,0,0,0,1.125-.492.442.442,0,0,0,.117-.27.274.274,0,0,0-.234-.234c-.094,0-.152.082-.234.2a.686.686,0,0,1-.7.34H8.527a1.812,1.812,0,0,0,.047-.363c0-1-.762-1.465-1.36-1.852l.2-.363a1.145,1.145,0,0,0,.176-.574.764.764,0,0,0-.774-.8.93.93,0,0,0-.914.973,1.2,1.2,0,0,0,.551,1.032C6.194-3.2,5.878-2.744,5.667-2.416ZM6.991-4.784a1.58,1.58,0,0,1-.2.551A.622.622,0,0,1,6.534-4.7c0-.223.129-.352.258-.352S6.991-4.972,6.991-4.784Zm.27,3.646c-.164,0-.293-.07-.293-.176s.07-.164.211-.164a3.6,3.6,0,0,1,.528.129A.558.558,0,0,1,7.261-1.138Z",
    transform: "translate(26.492 20.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8342",
    "data-name": "Trac\\xE9 8342",
    d: "M4.128-3.321a2.737,2.737,0,0,0-2.9,2.7c0,1.3,1.5,2.077,3.139,2.077A2.006,2.006,0,0,0,6.108-.665C6.108-1.969,5.48-3.321,4.128-3.321Z",
    transform: "translate(49.97 21.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8626",
    "data-name": "Trac\\xE9 8626",
    d: "M7.171,0C2.988,0,0,3.3,0,8.056c0,4.072,1.837,7.37,5.2,8.233a5.263,5.263,0,0,0,4.493,4.869c1.992.354,4.072-.376,4.515-1.217.111-.664-1.129-3.32-1.129-3.32a3.721,3.721,0,0,1-2.412.708c-.708-.133-.753-.664-.841-1.062C12.881,15.515,14.7,13.1,14.7,8.211,14.7,2.479,11.354,0,7.171,0Zm.354,4.117c2.08,0,2.789,1.793,2.789,4.382,0,2.147-.642,3.94-2.811,3.962-2.235.022-3.165-2.1-3.165-4.205C4.338,6.2,5.312,4.117,7.525,4.117Z",
    transform: "translate(33.507 0.769) rotate(-3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8625",
    "data-name": "Trac\\xE9 8625",
    d: "M.739,3.827c0,2.97,1.542,3.655,3,3.655a3.155,3.155,0,0,0,1.985-.7l.243.628S8.65,7.4,8.65,7.325s0-2.156-.014-2.156-.885-.157-.914-.186V.086L4.181.357l.114,2.028.942.043.014,1.014c0,.857-.371,1.442-.928,1.442-.685,0-1.014-.485-1.014-1.442C3.3.957,3.3,0,3.3,0L.025.228A9.14,9.14,0,0,0,.154,2.142l.6.057Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 50.116, 8.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8624",
    "data-name": "Trac\\xE9 8624",
    d: "M.653,0A30.366,30.366,0,0,0,.735,4.5c.2.1,2.788.265,2.788.265s.346-1.75.407-1.791,2.706-.1,2.808-.1S.043,10.848,0,10.909s.468,3.256.488,3.256H11.438s.244-5.29.1-5.474a12.881,12.881,0,0,0-2.584-.244c-.061,0-.346,2.177-.387,2.238s-3.276.2-3.337.2S11.5,3.054,11.58,3.014,11.255.145,11.255.063.653,0,.653,0Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 59.598, 5.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8623",
    "data-name": "Trac\\xE9 8623",
    d: "M1.47,0A1.459,1.459,0,0,0,0,1.559,1.471,1.471,0,0,0,1.635,3.089c1.02,0,1.394-.795,1.394-1.6A1.575,1.575,0,0,0,1.47,0Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 54.88, 4.701)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "idea_3_",
    "data-name": "idea (3)",
    transform: "translate(30.801 53.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5088",
    "data-name": "Groupe 5088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5087",
    "data-name": "Groupe 5087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8638",
    "data-name": "Trac\\xE9 8638",
    d: "M153.251,144.24a8.1,8.1,0,0,0-7.07-7.052,8.481,8.481,0,0,0-.959-.055,8.074,8.074,0,0,0-5.676,13.8,6.359,6.359,0,0,1,1.96,4.518v.933h7.453v-.938a6.219,6.219,0,0,1,1.891-4.445,8.048,8.048,0,0,0,2.4-6.766h0Z",
    transform: "translate(-127.842 -127.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8639",
    "data-name": "Trac\\xE9 8639",
    d: "M231.9,494.956a1.867,1.867,0,0,0,1.757-1.242h-3.514A1.866,1.866,0,0,0,231.9,494.956Z",
    transform: "translate(-214.505 -460.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8640",
    "data-name": "Trac\\xE9 8640",
    d: "M210.286,440.72a.622.622,0,0,0,.621.621h4.969a.622.622,0,0,0,.621-.621v-1.863h-6.211Z",
    transform: "translate(-196 -409.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8641",
    "data-name": "Trac\\xE9 8641",
    d: "M238.956,5.59A1.242,1.242,0,0,0,240.2,4.348V1.242a1.242,1.242,0,0,0-2.484,0V4.348A1.242,1.242,0,0,0,238.956,5.59Z",
    transform: "translate(-221.565 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8642",
    "data-name": "Trac\\xE9 8642",
    d: "M66.56,68.317a1.272,1.272,0,0,0,1.757,0,1.242,1.242,0,0,0,0-1.757l-2.2-2.2a1.242,1.242,0,1,0-1.757,1.757Z",
    transform: "translate(-59.652 -59.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8643",
    "data-name": "Trac\\xE9 8643",
    d: "M5.59,238.956a1.242,1.242,0,0,0-1.242-1.242H1.242a1.242,1.242,0,0,0,0,2.485H4.348A1.242,1.242,0,0,0,5.59,238.956Z",
    transform: "translate(0 -221.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8644",
    "data-name": "Trac\\xE9 8644",
    d: "M67.761,379.121a1.242,1.242,0,0,0-1.2.323l-2.2,2.2a1.242,1.242,0,0,0,0,1.757,1.271,1.271,0,0,0,1.757,0l2.2-2.2a1.242,1.242,0,0,0-.556-2.08Z",
    transform: "translate(-59.653 -353.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8645",
    "data-name": "Trac\\xE9 8645",
    d: "M381.2,379.444a1.242,1.242,0,1,0-1.757,1.757l2.2,2.2a1.271,1.271,0,0,0,1.757,0,1.242,1.242,0,0,0,0-1.757Z",
    transform: "translate(-353.326 -353.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8646",
    "data-name": "Trac\\xE9 8646",
    d: "M434.062,237.714h-3.106a1.242,1.242,0,0,0,0,2.485h3.106a1.242,1.242,0,0,0,0-2.485Z",
    transform: "translate(-400.522 -221.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8647",
    "data-name": "Trac\\xE9 8647",
    d: "M381.222,68.317l2.2-2.2a1.242,1.242,0,0,0-1.757-1.757l-2.2,2.2a1.242,1.242,0,0,0,0,1.757A1.272,1.272,0,0,0,381.222,68.317Z",
    transform: "translate(-353.347 -59.653)",
    fill: "#fff"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8648",
    "data-name": "Trac\\xE9 8648",
    d: "M-6.865-25.658c2.512.2,4.91-.476,4.91-3.6a3.594,3.594,0,0,0-3.859-3.728,3.71,3.71,0,0,0-3.366,2.3c-.066.394,1.593,1.823,1.593,1.823s.673-1.051,1.56-1.051a.78.78,0,0,1,.8.821c0,1-.887.985-1.642.985A12.152,12.152,0,0,0-6.865-25.658Zm1,1.2a1.6,1.6,0,0,0-1.609,1.708,1.611,1.611,0,0,0,1.79,1.675c1.117,0,1.527-.87,1.527-1.757A1.725,1.725,0,0,0-5.863-24.459Z",
    transform: "translate(53.74 99.108)",
    fill: "#4b75ad"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuiz);
export default __webpack_public_path__ + "static/media/icon-quiz.504b841e.svg";
export { ForwardRef as ReactComponent };